import { LocalizationKeys } from 'assets/localizations/localizationKeys';
import { BusinessErrorCode } from 'services/businessBilling/contract';
import { BUSINESS_ERROR_MESSAGE_KEYS, BUSINESS_UNKNOWN_MESSAGE_KEY } from 'services/businessBilling/messages';
import { ParsedBusinessResult } from 'services/businessBilling/parseResponse';

export type BusinessErrorSource =
    | { kind: 'code'; code: BusinessErrorCode; field: 'cui' | null }
    | { kind: 'unknown' };

export interface BusinessErrorDisplay {
    placement: 'field' | 'form'; // field: inline under the CUI input; form: a message block of the form.
    messageKey: LocalizationKeys;
}

/**
 * Where a business error appears and which message it shows. Decided only by the stable error code and the wire's
 * `field`: never by message text. Unknown outcomes show the generic verification message in the form, never an
 * invalid-CUI message.
 */
export const getErrorDisplay = (source: BusinessErrorSource): BusinessErrorDisplay => {
    if (source.kind === 'unknown') {
        return { placement: 'form', messageKey: BUSINESS_UNKNOWN_MESSAGE_KEY };
    }
    return {
        placement: source.field === 'cui' ? 'field' : 'form',
        messageKey: BUSINESS_ERROR_MESSAGE_KEYS[source.code],
    };
};

/** For the real parsed result (chunk 2): a failure keeps its code and field, anything unknown stays unknown. */
export const toErrorSource = (result: ParsedBusinessResult): BusinessErrorSource | null => {
    switch (result.kind) {
        case 'failure':
            return { kind: 'code', code: result.response.error.code, field: result.response.error.field };
        case 'unknown':
            return { kind: 'unknown' };
        default:
            return null;
    }
};
